import { useState, useEffect } from 'react';
import { useToast } from '../hooks/use-toast.js';
import React from 'react';

export default function AdminAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { toast } = useToast();

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        setLoading(true);
        // Directly use the test server URL
        const response = await fetch('http://localhost:3001/api/admin/appointments');
        
        if (!response.ok) {
          throw new Error('Failed to fetch appointments');
        }
        
        const data = await response.json();
        setAppointments(data);
      } catch (err) {
        console.error('Error fetching appointments:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
        toast({
          title: 'Error',
          description: 'Failed to load appointments',
          variant: 'destructive'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, [toast]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  if (loading) {
    return <div className="p-8 text-center">Loading appointments...</div>;
  }

  if (error) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-bold text-red-600 mb-2">Error</h2>
        <p>{error}</p>
        <p className="mt-4">Please make sure you have the proper permissions to access this page.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Appointment Management</h1>
      
      {appointments.length === 0 ? (
        <div className="text-center p-8 bg-gray-50 rounded-lg">
          <p className="text-gray-500">No appointments found</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-3 text-left font-medium">ID</th>
                <th className="p-3 text-left font-medium">Name</th>
                <th className="p-3 text-left font-medium">Contact</th>
                <th className="p-3 text-left font-medium">Service</th>
                <th className="p-3 text-left font-medium">Device</th>
                <th className="p-3 text-left font-medium">Date & Time</th>
                <th className="p-3 text-left font-medium">Status</th>
                <th className="p-3 text-left font-medium">Created</th>
              </tr>
            </thead>
            <tbody>
              {appointments.map((appointment) => (
                <tr key={appointment.id} className="border-b hover:bg-gray-50">
                  <td className="p-3">{appointment.id}</td>
                  <td className="p-3">{appointment.fullName}</td>
                  <td className="p-3">
                    <div>{appointment.email}</div>
                    <div className="text-sm text-gray-600">{appointment.phone}</div>
                  </td>
                  <td className="p-3">{appointment.serviceNeeded}</td>
                  <td className="p-3">
                    <div>{appointment.deviceType}</div>
                    <div className="text-sm text-gray-600">{appointment.deviceBrand} {appointment.deviceModel}</div>
                  </td>
                  <td className="p-3">
                    <div>{appointment.preferredDate}</div>
                    <div className="text-sm text-gray-600">{appointment.preferredTime}</div>
                  </td>
                  <td className="p-3">
                    <span className={`px-2 py-1 rounded-full text-xs ${appointment.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'}`}>
                      {appointment.status}
                    </span>
                  </td>
                  <td className="p-3 text-sm">{formatDate(appointment.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
